/**
 * Normalise RSVP first/last names for storage: lowercase, then capitalise the first letter
 * of each word (space- or hyphen-separated). Last names that begin with "Mc" use Irish-style
 * casing (e.g. McMahon, McDonald).
 */

function titleCaseSegment(segment: string): string {
    const s = segment.trim().toLowerCase();
    if (!s) {
        return '';
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
}

function formatWordWithHyphens(word: string, segmentFormatter: (seg: string) => string): string {
    return word
        .split('-')
        .map((seg) => segmentFormatter(seg))
        .join('-');
}

/**
 * Words starting with "mc" (length > 2) become Mc + capitalised remainder (e.g. mcmahon → McMahon).
 */
function formatLastNameSegment(segment: string): string {
    const s = segment.trim().toLowerCase();
    if (!s) {
        return '';
    }
    if (s.startsWith('mc') && s.length > 2) {
        const rest = s.slice(2);
        return `Mc${rest.charAt(0).toUpperCase()}${rest.slice(1)}`;
    }
    if (s === 'mc') {
        return 'Mc';
    }
    return titleCaseSegment(s);
}

export function formatRsvpFirstName(input: string): string {
    return input
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => formatWordWithHyphens(word, titleCaseSegment))
        .join(' ');
}

export function formatRsvpLastName(input: string): string {
    return input
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map((word) => formatWordWithHyphens(word, formatLastNameSegment))
        .join(' ');
}
